import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from 'components/ui/modal';
import Timeline from '@material-ui/lab/Timeline';
import { GET_LOGS } from 'graphql/colleges';
import Loading from 'components/common/Spin';
import { Query } from 'react-apollo';
import TimelineLog from './TimelineLog';

const styles = (theme) => ({
  root: {
    minWidth: 360,
  },
  input: {
    marginBottom: theme.spacing(3),
  },
});


const ShowLogs = ({ onClose, id }) => {
  return (
    <Modal title={`Logs`} open onClose={onClose}>
      <Query
        query={GET_LOGS}
        fetchPolicy={'cache-and-network'}
        variables={{ id }}
      >
        {({ data, loading }) => {
          if (loading || !data) return <Loading spinning />;
          const { rows } = data;

          return (
            <>
              <Timeline align="alternate">
                {rows.length
                  ? rows.map((log) => {
                      return <TimelineLog log={log} />;
                    })
                  : `No Logs Found`}
              </Timeline>
            </>
          );
        }}
      </Query>
    </Modal>
  );
};

export default withStyles(styles)(ShowLogs);
